/**
 * Arrondi commercial standard - 0 decimales pour les montants FCFA.
 */
export function roundFCFA(value: number): number {
  return Math.round(value);
}

export function roundDecimal(value: number, decimals: number): number {
  const factor = 10 ** decimals;
  return Math.round(value * factor) / factor;
}

/**
 * Cotisation FCFA = ROUND Excel (base × taux, 0), sans erreur de virgule flottante.
 * 4,1 % de 333 337 → 13 667 (et non 13 666,817 affiché tronqué).
 */
export function montantCotisation(base: number, taux: number): number {
  const b = roundFCFA(Math.max(0, base));
  if (b === 0 || taux === 0) return 0;
  const milliemes = Math.round(taux * 1_000_000);
  return Math.round((b * milliemes) / 1_000_000);
}
